import { combineReducers } from '@reduxjs/toolkit'
import emailConfigurationReducer from './configuration'
import emailSignatureReducer from './signature'

export const EmailSettingsReducer = combineReducers({
  configuration: emailConfigurationReducer,
  signature: emailSignatureReducer,
})
